// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KG5G","index":"styles_index__7nBhy"};